/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import GatewayMap from 'loracoms/GatewayMap';
import ShowIf from 'loracoms/ShowIf';
import HideIf from 'loracoms/HideIf';
import MapPicker from 'loracoms/MapPicker';
import SearchInput from 'loracoms/SearchInput';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';


const defaultProps = {
  show: false,
  onSave: () => {},
};

const propTypes = {
  gateways: React.PropTypes.array.isRequired,
  onHide: React.PropTypes.func.isRequired,
  show: React.PropTypes.bool,
  onSave: React.PropTypes.func,
  intl: React.PropTypes.object.isRequired,
};

class MapOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gateways: props.gateways,
      center: props.gateways[0],
      zoom: _.isNil(props.gateways[0]) ? 11 : 16,
      show: props.show,
      view: 'view',
    };
    this.intlMsg = new IntlMsg(props.intl, 'mapoverlay');
    this.handlePickPoint = this.handlePickPoint.bind(this);
    this.handleSaveLocation = this.handleSaveLocation.bind(this);
    this.handleHide = this.handleHide.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { gateways, show } = nextProps;
    if (gateways !== this.props.gateways) {
      this.setState({ gateways });
    }
    if (show !== this.props.show) {
      this.setState({ show });
    }
  }

  handlePickPoint(point) {
    this.setState({ point });
  }

  handleSaveLocation() {
    const { point } = this.state;
    this.props.onSave(point);
    this.handleHide();
  }

  handleHide() {
    this.setState({ view: 'view' });
    this.props.onHide();
  }

  handleOnChange(e) {
    const search = _.trim(e.target.value);
    this.setState({ search });
  }

  render() {
    const {
      gateways,
      show = false,
      view = 'view',
      point = {},
      center,
      zoom,
      search = '',
    } = this.state;

    if (!show) {
      return null;
    }

    return (
      <div className={styles.overlay}>
        <div className={`${styles.closeButton} ${styles.mapButton}`}>
          <Button bsStyle="aisz-link-default" onClick={this.handleHide}>
            <span className="glyphicons glyphicons-remove drop" />
          </Button>
        </div>
        <div className={`${styles.mapMarker} ${styles.mapButton}`}>
          <Button bsStyle="aisz-link-default" onClick={() => { this.setState({ view: 'edit' }); }}>
            <span className="glyphicons glyphicons-nearby-circle drop" />
            <HideIf if={view === 'edit' && !_.isEmpty(point)}>
              <span className={styles.buttonText}>{this.intlMsg.msg('edit')}</span>
            </HideIf>
          </Button>
          <ShowIf if={view === 'edit' && !_.isEmpty(point)}>
            <span className={styles.point}>{`(${point.lng},${point.lat})`}</span>
          </ShowIf>
          <ShowIf if={view === 'edit' && !_.isEmpty(point)}>
            <Button bsStyle="aisz-primary" onClick={this.handleSaveLocation}>
              {this.intlMsg.msg('submit')}
            </Button>
          </ShowIf>
        </div>
        <ShowIf if={view === 'view'}>
          <GatewayMap
            gateways={gateways}
            onZoom={(map) => {
              this.setState({
                center: map.getCenter(),
                zoom: map.getZoom(),
              });
            }}
            onDrag={(map) => {
              this.setState({
                center: map.getCenter(),
              });
            }}
          />
        </ShowIf>
        <ShowIf if={view === 'edit'}>
          <div className={`pull-right ${styles.searchinput}`}>
            <SearchInput
              value={search}
              onChange={e => this.handleOnChange(e)}
              placeholder="search"
            />
          </div>
        </ShowIf>
        <ShowIf if={view === 'edit'}>
          <MapPicker
            point={center}
            zoom={zoom}
            onPick={this.handlePickPoint}
            search={search}
          />
        </ShowIf>
      </div>
    );
  }
}


MapOverlay.defaultProps = defaultProps;
MapOverlay.propTypes = propTypes;

const mapStateToProps = state => ({
  gateway: state.gateway.gateway,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MapOverlay));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/MapOverlay/index.jsx